import React from 'react'
import FooterPages from './Footer/FooterPages'
import UserService from '../services/UserService'
import Navbar2 from './Navbars/Navbar2'
import Navbar3 from './Navbars/Navbar3'
import AuthService from '../services/AuthService'
function PageNotFound() {
    return (
        <>
        <Navbar3  />
        <div className="bgpages">
    <div className=' container py-3'>
          {/* <div className='greentheme '>{`Page Not Found`}</div> */}
          <div className='p-2 bg-white greentheme my-3' style={{ fontSize: "20px" }}><b> Page Not Found</b></div>
          <div className='card p-3 my-3'>
        <div className='my-2'>                        {UserService.isLoggedIn()?UserService.hasRole(["adminrole"])?"Please login to access!! ":"  Please login with Admin user to access!!":"Please login to access!!"}</div>

          </div>
          </div></div>
 
                      <FooterPages/></>
        
        )
}

export default PageNotFound